angular.module('tgaAdmin').controller('HubLeaderboardModalController', [
  '$scope',
  '$state',
  '$window',
  '$uibModalInstance',
  '$uibModalStack',
  'customFieldService',
  'extras',
  '$translate',
  function ($scope, $state, $window, $uibModalInstance, $uibModalStack, customFieldService, extras, $translate) {
    $scope.data = {
      alerts: [],
      closeButton: extras.closeButton,
      countupOptions: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ':',
      },
      datePickerOptions: {
        clearable: false,
        opens: 'left',
        alwaysShowCalendars: true,
        showCustomRangeLabel: true,
        maxDate: moment().endOf('day'),
        locale: {
          format: 'M/D/YYYY',
          customRangeLabel: 'Custom',
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [
            moment()
              .subtract(1, 'month')
              .startOf('month'),
            moment()
              .subtract(1, 'month')
              .endOf('month'),
          ],
          'Last 12 Months': [
            moment()
              .subtract(11, 'month')
              .startOf('month'),
            moment(),
          ],
          'This Year': [moment().startOf('year'), moment()],
        },
        eventHandlers: {
          'apply.daterangepicker': function (ev, picker) {
            $scope.viewmodel.range = picker.chosenLabel;

            if (
              !$scope.viewmodel.dateRange.startDate.isSame($scope.viewmodel.oldRange.startDate, 'day')
              || !$scope.viewmodel.dateRange.endDate.isSame($scope.viewmodel.oldRange.endDate, 'day')
            ) {
              $scope.viewmodel.dateRange = $scope.viewmodel.oldRange = {
                startDate: picker.startDate,
                endDate: picker.endDate,
              };
              $scope.actions.loadChart();
            }
          },
          'outsideClick.daterangepicker': function () {
            $scope.viewmodel.dateRange = {
              startDate: $scope.viewmodel.oldRange.startDate,
              endDate: $scope.viewmodel.oldRange.endDate,
            };
          },
        },
      },
    };

    $scope.viewmodel = {
      range: 'Last 30 Days',
      oldRange: {
        startDate: moment().subtract(29, 'days'),
        endDate: moment(),
      },
      dateRange: {
        startDate: moment().subtract(29, 'days'),
        endDate: moment(),
      },
    };
    $scope.loading = false;

    $scope.initialize = function () {
      $scope.loading = false;
    };

    $scope.actions = {
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };
    $scope.initialize();
  },
]);
